export default class ScrollToTop {
    private readonly visibleClass = "visible";
    private readonly scrollYThreshold = 100;

    private isVisible: boolean;
    private button: HTMLElement;

    constructor(button: HTMLElement) {
        this.isVisible = false;

        this.button = button;
        this.button.addEventListener("click", () => this.scrollToTop());
        window.addEventListener("scroll", () => this.update(), { passive: true });
    }

    private checkBackground() {
        const rect = this.button.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;
        const elements = document.elementsFromPoint(x, y);
        const isOverFooter = elements.some((el) => el.id == "Footer");
        this.button.classList.toggle("over-footer", isOverFooter);
    }

    private update() {
        let y = window.scrollY;

        let visible = y > this.scrollYThreshold;

        if (visible) {
            this.checkBackground();
        }

        if (visible === this.isVisible) {
            return;
        }

        this.isVisible = visible;
        this.button.classList.toggle(this.visibleClass, visible);
    }

    public scrollToTop() {
        this.button.blur();
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
    }
}
